"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkForIcon = void 0;
const checkForIcon = tooltipLabel => {
  let icon;
  if (Array.isArray(tooltipLabel)) {
    icon = true;
  } else {
    icon = false;
  }
  return icon;
};
exports.checkForIcon = checkForIcon;